/* eslint-disable react/prop-types,no-param-reassign */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import Bind from 'lodash-decorators/bind';
import Debounce from 'lodash-decorators/debounce';

import { Row, Column } from 'hedron';
import Container from 'blocks/Container/Container';
import { media, isOnMobile } from 'designsystem/index';
import { Banner as BannerModel } from 'models';
import styled from 'styled-components';
import ds from 'designsystem';
import Fade from 'react-reveal/Fade';
import Button from 'elements/Button';
import { FADE_VALUES, parallaxImage } from 'animations/Animations';
import Paragraph from 'elements/Paragraph';
import HTMLModifiableBackground from 'blocks/HTMLModifableBackground/HTMLModifiableBackground';
import { SmoothScrollLink } from 'organism-react-scroll-nav';
import { safeHtmlWithBr } from 'common/methods/string';
import Image from './Image';
import Header from './Header';

const TagAScroll = styled.a`
  text-decoration: none;
`;

const Banner = styled.div`
    ${media.desktop`
        padding: calc(${ds.get('metrics.base')} * 7) 0;
    `};
`;

@inject('productsStore', 'windowStore')
@observer
export default class BannerBlock extends Component {
  isMobile = observable.box(isOnMobile());

  static propTypes = {
    data: PropTypes.instanceOf(BannerModel).isRequired,
  };

  constructor(props) {
    super(props);
    this.elementRef = React.createRef();
  }

  componentDidMount() {
    const { windowStore } = this.props;
    this.disposeOnScroll = windowStore.reactToScroll(this.onScroll);
  }

  componentWillUnmount() {
    this.disposeOnScroll();
  }

  @Bind()
  onScroll() {
    parallaxImage(this.elementRef.current, 55, -55, 10);
  }

  @Bind()
  @Debounce(200)
  updateDimensions() {
    this.isMobile.set(isOnMobile());
  }

  renderScrollButton(buttonText, buttonLink) {
    if (buttonLink) {
      return (
        <TagAScroll href={buttonLink}>
          <Button>{buttonText}</Button>
        </TagAScroll>
      );
    }

    const { productsStore } = this.props;
    const navElementsLength = productsStore.parsedStructure.length;
    return (
      <SmoothScrollLink
        container={(
          <TagAScroll href={`#scroll-${navElementsLength}`}>
            <Button>
              {buttonText}
            </Button>
          </TagAScroll>
        )}
        targetId={`scroll-${navElementsLength}`}
        scrollMargin={70}
      />
    );
  }

  render() {
    const {
      data: {
        header,
        text,
        buttonText,
        image,
        htmlModifiers,
        buttonLink,
      },
      windowStore,
    } = this.props;
    return (
      <HTMLModifiableBackground
        htmlModifiers={htmlModifiers}
        color={ds.brand('background')}
      >
        <Container>
          <Banner>
            <Row alignItems="flex-start">
              <Column lg={4}>
                <Fade bottom distance={`${FADE_VALUES.BOX.SMALL}`} delay={FADE_VALUES.DELAY.SMALL}>
                  <Header dangerouslySetInnerHTML={{
                    __html: safeHtmlWithBr(header),
                  }}
                  />
                  <Paragraph
                    dangerouslySetInnerHTML={{
                      __html: text,
                    }}
                  />
                  {!this.isMobile.get()
                    ? (
                      this.renderScrollButton(buttonText, buttonLink)
                    ) : ''
                  }
                </Fade>
              </Column>
              <Column lg={7} lgShift={1}>
                <Fade bottom distance={`${FADE_VALUES.BOX.SMALL}`} delay={FADE_VALUES.DELAY.SMALL}>
                  <Image src={windowStore.adjustImageSize(image)} innerRef={this.elementRef} />
                  {this.isMobile.get()
                    ? (
                      this.renderScrollButton(buttonText, buttonLink)
                    ) : ''
                  }
                </Fade>
              </Column>
            </Row>
          </Banner>
        </Container>
      </HTMLModifiableBackground>
    );
  }
}



// WEBPACK FOOTER //
// ./src/kentico-blocks/Banner/index.jsx